module.exports = __webpack_public_path__ + "fonts/ChurchwardMarianna-Regular.4796697c.eot";